import { QueryResult, useQuery } from '@apollo/client'
import { ScoreGridWithHistoryQuery, ScoreGridWithHistoryQueryVariables, Country } from '../../../types'
import { SCORE_GRID_QUERY } from '../Queries'

export const useScoreGrid = (
  meetingId: number,
  employeeId: number,
  country: Country,
  hasEvaluationStep: boolean,
): QueryResult<ScoreGridWithHistoryQuery, ScoreGridWithHistoryQueryVariables> => {
  return useQuery<ScoreGridWithHistoryQuery, ScoreGridWithHistoryQueryVariables>(SCORE_GRID_QUERY, {
    variables: { meetingId, employeeId, country },
    fetchPolicy: 'network-only',
    skip: !hasEvaluationStep,
  })
}
